export default class VueErrorException extends Error {
  constructor(...args) {
    super(...args);
    Error.captureStackTrace(this, VueErrorException);

    this.name = 'VueErrorException';
  }
}



// WEBPACK FOOTER //
// ./src/exceptions/VueErrorException.js